type ClassifyStepType =
  | 'screenshot-partial'
  | 'classify'
  | 'transcribe-partial';
type ProcessStepType =
  | 'screenshot'
  | 'transcribe'
  | 'style'
  | 'facts'
  | 'combine';
type RestorationStepType = 'restoration';

export type StepType = ClassifyStepType | ProcessStepType | RestorationStepType;

export const STEP_LABELS: Record<StepType, string> = {
  'screenshot-partial': 'Getting some first impressions…',
  classify: 'Analyzing the content…',
  'transcribe-partial': "Catching what's being said…",
  screenshot: 'Capturing all the key moments…',
  transcribe: 'Getting every word down…',
  style: 'Reading between the frames…',
  facts: 'Collecting the highlights…',
  combine: 'Assembling the pieces…',
  restoration: 'Restoring…'
};

export type PersonaImportStepProcess = {
  stepType: StepType;
  expectedNum: 1 | 'n';
};

export type CombinedSteps = {
  progress: number;
  errors: string[];
  completed: boolean;
  stepDetails: { stepType: StepType; completed: boolean }[];
};

export const CLASSIFY_STEPS: PersonaImportStepProcess[] = [
  { stepType: 'screenshot-partial', expectedNum: 1 },
  { stepType: 'classify', expectedNum: 1 },
  { stepType: 'transcribe-partial', expectedNum: 1 }
];

export const PROCESS_STEPS: PersonaImportStepProcess[] = [
  { stepType: 'screenshot', expectedNum: 1 },
  { stepType: 'transcribe', expectedNum: 'n' },
  { stepType: 'style', expectedNum: 'n' },
  { stepType: 'facts', expectedNum: 'n' },
  { stepType: 'combine', expectedNum: 1 }
];
